import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getDairyCowTypes } from "services";

import { DEFAULT_CACHE_TIME, GET_DAIRY_COW_TYPES } from "consts";

import { DairyCowType, WithInjectedName } from "models";

export const useGetDairyCowTypes = ({ enabled }: { enabled?: boolean } = {}) => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("footprintingDairy", { useSuspense: false });

  return useQuery<Array<WithInjectedName<DairyCowType>>>({
    queryKey: [GET_DAIRY_COW_TYPES, { enabled }],
    queryFn: async () => {
      const cowTypes = await getDairyCowTypes({ enabled });
      return cowTypes.map((c) => ({ ...c, name: t(`cowTypes.${c.translationSlug}`) }));
    },
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
